import { useAngularContext } from 'AngularContext';

export function useResourcesAuthenticationHelper() {
    const $injector = useAngularContext();
    const ResourcesAuthenticationHelper = $injector.get<{ getAuthenticationToken: () => Promise<string> }>(
        'ResourcesAuthenticationHelper',
    );
    return ResourcesAuthenticationHelper;
}
